import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TProgramBroadcast, TProgramBroadcastSegmentsPatch } from '../types';

import { broadcastScheduleQueryKeys } from './query-keys';

export async function patchProgramBroadcasts(
  body: TProgramBroadcastSegmentsPatch
): Promise<TProgramBroadcast> {
  return mediaManagerClient.patch(`/api/v1/program_broadcasts/${body.id}`, emptyStringValues(body));
}

type MutationFn = typeof patchProgramBroadcasts;

type TUsePostBroadcastersParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchProgramBroadcasts({ config = {} }: TUsePostBroadcastersParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchProgramBroadcasts,
    onError(error) {
      addErrorNotification(
        t('El programa no se ha actualizado'),
        t('Ha habido un fallo en el proceso')
      );
      console.error(error);
    },
    onSuccess(data, variables, context) {
      config.onSuccess?.(data, variables, context);
      addSuccessNotification(t('Se ha actualizado el programa'), t('El proceso ha sido un éxito'));
      queryClient.invalidateQueries({ queryKey: broadcastScheduleQueryKeys.all });
    },
  });
}
